enum TimeReferenceType {
	EVENT = 'event',
	SPAN = 'span'
}
export default TimeReferenceType;